<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button :disabled="!companyLayout.permission.addEngagements" @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_angagements_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            :label="$t('settings_engagements_name')"
                            width="250">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            :label="$t('settings_engagements_createDate')"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="email"
                            :label="$t('settings_engagements_email')"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="code"
                            :label="$t('settings_engagements_code')"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            width="150"
                            :label="$t('settings_engagements_operations')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    :disabled="!companyLayout.permission.updateEngagements"
                                    @click="openModalAdd('update', scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    :disabled="!companyLayout.permission.deleteEngagements"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- [ Modal add engagement] start -->
        <sweet-modal blocking :title="operation === 'create' ? `${$t('settings_angagements_add')} ${btnText}` : `${$t('settings_engagements_edit')} ${btnText}`" ref="addEngagement" class="modal" v-on:close="closeModal">

            <el-form :model="form" status-icon ref="form" :rules="rules" class="demo-ruleForm">
                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item :label="placeholderText" label-width="135px" prop="name">
                            <el-input :label="btnText + ` ${$t('settings_engagements_name')}`" v-model="form.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('settings_engagements_stage')" label-width="135px" prop="engagementStageId">
                            <el-select v-model="form.engagementStageId" :placeholder="$t('settings_engagements_stage')">
                                <el-option
                                        v-for="item in form.engagementStageList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item label="" label-width="135px">
                            <div class="description-btn">
                                <el-button slot="button" v-on:click="$refs.nestedChild.open()">{{$t('settings_engagements_engagementDescription')}}</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('settings_engagements_code')" label-width="135px" prop="code">
                            <el-input :label="$t('settings_engagements_code')" v-model="form.code"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item label="Email" label-width="135px" prop="email">
                            <el-input :label="$t('settings_engagements_email')" v-model="form.email"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="addEngagement" :label="$t('settings_engagements_taskTemplate')" label-width="135px" prop="taskTree">
                            <el-select v-model="form.taskTreeId" :placeholder="$t('settings_engagements_taskTemplate')">
                                <el-option
                                        v-for="item in form.taskTree"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item prop="businessUnitId" size="mini" :label="$t('settings_engagements_engagementOwner')" label-width="135px">
                            <el-select v-model="form.businessUnitId" :placeholder="$t('settings_engagements_engagementOwner')">
                                <el-option
                                        v-for="bu in form.businessUnitList"
                                        :key="bu.id"
                                        :label="bu.name"
                                        :value="bu.id"
                                        @click.native="handleSelectBu(bu.id, bu.leaderBU)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  prop="managerId" size="mini" :label="$t('settings_engagements_engagementLeader')" label-width="135px">
                            <el-select disabled v-model="form.managerId" :placeholder="$t('settings_engagements_engagementLeader')">
                                <el-option
                                        v-for="leader in form.managers"
                                        :key="leader.id"
                                        :label="leader.user.fullName"
                                        :value="leader.id"
                                        :class="{ disabled: leader.status != 1 }"
                                        @click.native="handleSelectLeader(leader.id, leader.businessUnitId)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item prop="engagementTeamBuId" :label="$t('settings_engagements_engagementBus')" size="mini" label-width="135px">
                            <el-select no-data-text="no date" @remove-tag="removeBuTag" v-model="form.engagementTeamBuId" multiple :placeholder="$t('settings_engagements_engagementBus')">
                                <el-option
                                        v-for="item in form.businessUnitList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectTeamBu(item.id, item.leaderBU)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="engagementTeamId" :label="$t('modal_engagements_buManagers')" size="mini" label-width="135px">
                            <el-select disabled no-data-text="no date" @remove-tag="removeTag" v-model="form.teamId" multiple :placeholder="$t('modal_engagements_managementTeam')">
                                <el-option
                                        v-for="item in form.team"
                                        :key="item.id"
                                        :label="item.user.fullName"
                                        :value="item.id"
                                        :class="{ disabled: item.status != 1 }"
                                        @click.native="handleSelectTeam(item.id)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :span="24">
                    <el-col :span="12">
                        <el-form-item :label="$t('modal_engagements_clients')" label-width="135px" prop="clientsId">
                            <el-select no-data-text="no date" v-model="form.clientsId" multiple :placeholder="$t('modal_engagements_engagementsClients')">
                                <el-option
                                        v-for="item in form.clients"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('modal_engagements_vendors')" label-width="135px" prop="vendorsId">
                            <el-select no-data-text="no date" v-model="form.vendorsId" multiple :placeholder="$t('modal_engagements_engagementsVendors')">
                                <el-option
                                        v-for="item in form.vendors"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-form-item :label="$t('modal_engagements_bill')" label-width="135px">
                        <el-col :span="24">
                            <el-radio-group v-model="form.bill">
                                <el-radio :label="0">{{$t('modal_engagements_single')}}</el-radio>
                                <el-radio :label="1">{{$t('modal_engagements_consolidate')}}</el-radio>
                                <el-radio :label="2">{{$t('modal_engagements_notBillable')}}</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-form-item>
                </el-row>

                <!-- <div class="modal__btn"> -->
                    <el-form-item v-if="operation === 'create'" class="modal__btn">
                        <el-button @click="modalCancel('addEngagement')">{{$t('general_cancel')}}</el-button>
                        <el-button @click="addEngagementSubmit('form')" type="primary">{{$t('general_submit')}}</el-button>
                    </el-form-item>
                    <el-form-item v-else class="modal__btn">
                        <el-button @click="modalCancel('addEngagement')">{{$t('general_cancel')}}</el-button>
                        <el-button @click="editEngagementSubmit('form')" type="primary">{{$t('general_submit')}}</el-button>
                    </el-form-item>
                <!-- </div> -->
            </el-form>
        </sweet-modal>


        <sweet-modal blocking ref="nestedChild">
            <vue-editor
              v-model="form.description"
              useCustomImageHandler
              @image-added="handleImageAdded"
            ></vue-editor>
            <el-button slot="button" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('general_submit')}}</el-button>
        </sweet-modal>

        <!--<sweet-modal blocking ref="confirmation" :title="`Delete ` + btnText">-->
            <!--Are you sure you want to delete this {{btnText}}?-->
            <!--<template slot="box-action">-->
                <!--<el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;-->
            <!--</template>-->
        <!--</sweet-modal>-->
    </div>
</template>

<script>

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import { VueEditor } from 'vue2-editor'

  export default {
    name: 'company-engagements',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

      VueEditor
    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      }
    },
    mounted(){

    },
    data() {
      return {
        addEngagement: true,
        placeholderText: this.$i18n.t('settings_engagements'),
        btnText: this.$i18n.t('settings_engagements'),
        tableData: [],
        operation: 'create',
        selectedRowId: '',
        moment:moment,
        state: 'engagements',
        form: {
          bill: 0,
          name: '',
          engagementStageId: null,
          // businessCenters: [],
          // businessCenterId: '',
          description: '',
          email:'',
          businessUnitId: null,
          managerId:'',
          engagementTeamBuId: [],
          teamId:[],
          clients:'',
          clientsId: [],
          vendors: '',
          vendorsId: [],
          taskTree:[],
          taskTreeId: null,
          code: '',
          // list
          engagementStageList: [],
          managers: [],
          businessUnitList: [],
          team:[]
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          engagementStageId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          businessUnitId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          engagementTeamBuId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          code:[
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          // managerId:[
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          // ],
          clientsId:[
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        loadingModal:false
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(state){
        let loader = this.$loading.show();
        this.state = state;
        if(state === 'projectTaskExpenseCategories'){
          this.btnText = 'Category';
          this.placeholderText = 'Category/Account'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      addEngagementSubmit(form){
        this.$refs[form].validate((valid) => {
            if (valid) {
        if (this.form.taskTreeId === 0){
          this.form.taskTreeId = null
        }
        let data = {
          name: this.form.name,
          description: this.form.description,
          email: this.form.email,
          managerCompanyUserId: this.form.managerId,
          companyUserIdList: this.form.teamId,
          engagementStageId: this.form.engagementStageId,
          businessUnitIdLeader: this.form.businessUnitId,
          businessUnitIdManagerArr: this.form.engagementTeamBuId,
          engagementTemplateId: this.form.taskTreeId,
          code: this.form.code,
          companyClientIdList: this.form.clientsId,
          companyVendorIdList: this.form.vendorsId,
          bill: this.form.bill,
        };
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, data)
          .then(response => {
            console.log('---', response.data);
            if (response.data.success){
              this.loadList(this.state);
              this.notification("Success", `${this.$t('settings_angagements_add')} ${this.btnText}`, "success");
              this.$refs.addEngagement.close()
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
            } else {
              console.log('error submit!!');
              return false;
            }
        });
      },
      openModalAdd(operation, index, row){
        this.operation = operation;
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
          .then(response => {
            this.form.managers = response.data.companyUserList;
            this.form.team = response.data.companyUserList;
            this.form.businessUnitList = response.data.businessUnitList;
            this.form.engagementStageList = response.data.engagementStageList;
            this.form.taskTree = response.data.engagementTemplateList;
            this.form.clients = response.data.companyClientList;
            this.form.vendors = response.data.companyVendorList;
            this.$refs.addEngagement.open();
            if(operation === 'update'){
              this.handleEdit(index, row)
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalEdit(){

      },
      openModalDelete(){

      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, this.form)
              .then(response => {
                this.$refs.openModal.close();
                this.$store.dispatch('getMenuStatistics');
                this.loadList(this.state)
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        // console.log('---', this.form.imageUrl);
        var formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            let url = response.data.fileUrl; // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      handleSelectBu(businessUnitId, leaderBu) {
        // set leader to leader input
        this.form.managerId = leaderBu.id;

        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.form.engagementTeamBuId.some(even);
        if (!ifBuInTeam) {
          this.form.engagementTeamBuId.push(businessUnitId);

          // set manager to manager list
          const evenManagers = (element) => element === leaderBu.id;
          const ifUserInManagers = this.form.teamId.some(evenManagers);
          if (!ifUserInManagers) {
            this.form.teamId.push(leaderBu.id);
          }
        }
      },
      handleSelectLeader(leaderId, businessUnitId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.form.teamId.some(even);
        if (!ifUserInTeam) {
          this.form.teamId.push(leaderId)
        }
        this.form.businessUnitId = businessUnitId;
      },
      removeBuTag(businessUnitId) {
        if(this.form.businessUnitId === businessUnitId) {
          this.form.businessUnitId = null;
          this.form.managerId = null
        }

        this.form.teamId = [];
        this.form.engagementTeamBuId.forEach(buId => {
          const leader = this.form.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;

          // check if user in managers
          const even = (val) => val === leader.id;
          const ifUserInTeam = this.form.teamId.some(even);

          if (!ifUserInTeam) {
            this.form.teamId.push(leader.id);
          }
        });
      },
      handleSelectTeamBu(businessUnitId, leaderBu) {
        console.log('businessUnitId, leaderBu', businessUnitId, leaderBu)
        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.form.engagementTeamBuId.some(even);

        // check if removed bu selected for leader
        if (!ifBuInTeam && this.form.businessUnitId === businessUnitId) {
          this.form.businessUnitId = null;
          this.form.managerId = null;
        }

        if(!ifBuInTeam) {
          // need to check if selected team still have the same leader
          this.form.teamId = [];
          this.form.engagementTeamBuId.forEach(buId => {
            const leader = this.form.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;
            // check if user in managers
            const even = (val) => val === leader.id;
            const ifUserInTeam = this.form.teamId.some(even);

            if (!ifUserInTeam) {
              this.form.teamId.push(leader.id);
            }
          });

        }else {
          const even = (element) => element === leaderBu.id;
          const ifLeaderInTeam = this.form.teamId.some(even);
          if(!ifLeaderInTeam) {
            this.form.teamId.push(leaderBu.id)
          }
        }
      },
      removeTag(userId){
        if(this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      handleSelectTeam(userId){
        const even = (element) => element === userId;
        const ifUserInTeam = this.form.teamId.some(even);
        if(!ifUserInTeam && this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      closeModal(){
        this.form.bill = 0;
        this.form.name = '';
        this.form.code = '';
        this.form.description = '';
        this.form.email = '';
        this.form.managerId = '';
        this.form.engagementStageId = '';
        this.form.engagementStageList = [];
        this.form.businessUnitId = '';
        this.form.businessUnitList = [];
        this.form.managers = [];
        this.form.client = [];
        this.form.clients = [];
        this.form.team = [];
        this.form.teamId = [];
        this.form.vendors = [];
        this.form.clientsId = [];
        this.form.vendorsId = [];
        this.$refs['form'].resetFields();
      },
      handleEdit(index, row) {
        let loader = this.$loading.show();
        this.selectedRowId = row.id;
        let Id = 'engagementId';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/item?companyId=${this.$route.query.companyId}&${Id}=${row.id}`)
          .then(response => {
            if (response.data.success){
              this.form.name = response.data.item.name;
              this.form.code = response.data.item.code;
              this.form.description = response.data.item.description;
              this.form.phone = response.data.item.phone;
              this.form.engagementStageId = response.data.item.engagementStageId;
              this.form.phoneExtension = response.data.item.phone2;
              this.form.email = response.data.item.email;
              this.form.managerId = response.data.item.managerCompanyUserId;

              this.form.businessUnitId = response.data.item.businessUnitLeader;
              this.form.engagementTeamBuId = response.data.item.businessUnitManagerArr;

              this.form.teamId = response.data.item.companyUserIdList;
              this.form.clientsId = response.data.item.companyClientIdList;
              this.form.vendorsId = response.data.item.companyVendorIdList;
              this.form.bill = response.data.item.bill
            }
            loader.hide()
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      editEngagementSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              name: this.form.name,
              description: this.form.description,
              email: this.form.email,
              managerCompanyUserId: this.form.managerId,
              companyUserIdList: this.form.teamId,
              engagementStageId: this.form.engagementStageId,
              // businessUnitId: this.form.businessUnitId,
              businessUnitIdLeader: this.form.businessUnitId,
              businessUnitIdManagerArr: this.form.engagementTeamBuId,
              code: this.form.code,
              companyClientIdList: this.form.clientsId,
              companyVendorIdList: this.form.vendorsId,
              bill: this.form.bill,
            };
            let Id = 'engagementId';
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, data)
              .then(response => {
                this.notification(this.$t('modal_settings_success'), `${this.$t('settings_engagements_edit')} ${this.btnText}`, "success");
                this.$refs.addEngagement.close();
                this.loadList(this.state);
                loader.hide()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id;
        this.$confirm(this.$t('settings_engagements_ThisWillPermanentlyDeleteTheEngagementsContinue'), this.$t('settings_engagements_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });
          let Id = 'engagementId';
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close();
              this.$store.dispatch('getMenuStatistics');
              this.loadList(this.state)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      deleteConfirm(){
        let Id = 'engagementId';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
          .then(response => {
            // this.$refs.confirmation.close()
            this.loadList(this.state)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      showMenu() {
        this.open = true;
      },
      hideMenu() {
        this.open = false;
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      tableData(val){
        val.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
    .flex-center{
        display:flex;
        justify-content:center;
    }
    .modal {
      &__title {
        text-align: center;
      }
      &__btn {
        text-align: right;
      }
    }
</style>

<style>

</style>
